import request from '@/utils/request'

// 获取表单列表
export const getFormList = (data) => request({
  url: '/bd/form/getFormList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 新增表单
export const addForm = (data) => request({
  url: '/bd/form/addForm',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 更新表单
export const updateForm = (data) => request({
  url: '/bd/form/updateForm',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 删除表单
export const delForm = (formId) => request({
  url: '/bd/form/delForm',
  method: 'get',
  params: { formId }
})
// 获取表单项
export const getFormItem = (formId) => request({
  url: '/bd/form/getFormInfo',
  method: 'get',
  params: { formId }
})
// 获取筛选项
export const getFilterItem = (formId) => request({
  url: '/bd/form/getFilterFieldList',
  method: 'get',
  params: { formId }
})
// 保存筛选项
export const saveFilterItem = (data) => request({
  url: '/bd/form/saveFilterField',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 获取列表项
export const getColumnItem = (formId) => request({
  url: '/bd/form/getShowFieldList',
  method: 'get',
  params: { formId }
})
// 保存列表项
export const saveColumnItem = (data) => request({
  url: '/bd/form/saveShowField',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})

// 获取省市区树
export const getRegionTree = () => request({
  url: '/bd/region/list',
  method: 'get'
})
// 获取字典列表
export const getDictList = (name) => request({
  url: '/component/dictionary/dict/list',
  method: 'get',
  params: { name }
})
// 获取字典项列表
export const getDictItemList = (code) => request({
  url: '/component/dictionary/getDictValueByCode',
  method: 'get',
  params: { code }
})
// 更新表单项
export const saveFormItem = (data) => request({
  url: '/bd/form/updateFormField',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 部门列表
export const getDepartmentListApi = () => request({
  url: '/base/department/getDeptTree',
  method: 'get'
})
// 根据用户权限获取部门
export const getUserInfo = (userId) => request({
  url: `/bd/teacher/getUserInfo`,
  method: 'get',
  params: { userId }
})
// 获取应用列表
export const getAppListApi = (data) => request({
  url: '/bd/operation/list',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 字典获所属应用
export const getDictApi = () => request({
  url: '/component/dictionary/getDictValueByCode',
  method: 'get',
  params: { code: 'formModule' }
})